import axios from 'axios';
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import _constantUtil from '../utils/Constant';
import Loader from '../components/partials/Loader';
import config from '../config/config';
import mobileBar from '../assets/images/232213.jpg'
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';

const {
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    EMPTY_STRING: emptyString,
    RESET_PASSWORD_END_POINT,
} = _constantUtil;

function NewPassword() {
    const navigate = useNavigate();
    const location = useLocation();
    const emailAdd = location.state?.email || emptyString;

    const [password, setPassword] = useState(emptyString);
    const [confirmPass, setConfirmPass] = useState(emptyString);
    const [loading, setLoading] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);
    const [visibility, setVisibility] = useState(falseValue);
    const [visibility1, setVisibility1] = useState(falseValue);

    //* execute reset password api
    const executeResetPasswordApi = async (event) => {
        event.preventDefault();

        //* set loading to true
        setLoading(trueValue);
        setDisableButton(trueValue);

        //* create data
        const data = {
            email: emailAdd,
            password: password,
            password_confirmation: confirmPass,
        };

        try {
            const res = await axios.post(`${config.appBaseUrl + RESET_PASSWORD_END_POINT}`, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const result = res.data;
            if (result.status) {
                toast.success(result.message);
                setTimeout(() => {
                    navigate('/login');
                    setLoading(falseValue);
                    setDisableButton(falseValue);
                }, 2000);
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);
        } finally {
            setLoading(falseValue);
            setDisableButton(falseValue);
        }
    };

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className="grid">
                <div className="order__left centered d-flex align-items-center justify-content-center">
                    <form onSubmit={executeResetPasswordApi}>
                        <div className="form">
                            <div className="logo">
                                <h3 className='text-center'>Hire a Vendor for professionals</h3>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <p className='text-center'>Create a new password to regain access to your account..</p>
                            </div>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={visibility ? 'text' : 'password'}
                                    id="password"
                                    name="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className='mb-0'
                                    autoComplete="off"
                                />
                                <button
                                    type="button"
                                    onClick={() => setVisibility((prev) => !prev)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {visibility ? <IoMdEyeOff size={18} /> : <IoMdEye size={18} />}
                                </button>
                            </div>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={visibility1 ? 'text' : 'password'}
                                    id="confirmPass"
                                    name="confirmPass"
                                    placeholder="Enter confirm passowrd"
                                    value={confirmPass}
                                    onChange={(e) => setConfirmPass(e.target.value)} 
                                    autoComplete="off"
                                />
                                <button
                                    type="button"
                                    onClick={() => setVisibility1((prev) => !prev)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {visibility1 ? <IoMdEyeOff size={18} /> : <IoMdEye size={18} />}
                                </button>
                            </div> 
                            <button type="submit" className="login__button" disabled={disableButton}>
                                {!loading ? 'Submit' : <Loader />}
                            </button>
                            <div className="signup">
                                <label className="remember_me">Already have an account?</label>
                                <Link
                                    to="/login"
                                    className="forgot__password text-golden"
                                    style={{ textDecoration: "none" }}
                                >
                                    <strong>Login</strong>
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="order__right centered no__overflow d-none d-md-block">
                    <img
                        className="img"
                        src={mobileBar}
                        alt="picture"
                    />
                </div>
            </div>
        </>
    );
}

export default NewPassword;